import React, { useEffect } from "react";
import "./Testamonial.css";
import { FaLocationArrow } from "react-icons/fa6";

const Testamonial = () => {
  useEffect(() => {
    // Load SociableKit script once
    if (!document.querySelector('script[src*="sociablekit"]')) {
      const script = document.createElement("script");
      script.src = "https://widgets.sociablekit.com/google-reviews/widget.js";
      script.defer = true;
      document.body.appendChild(script);
    }

    let initialized = false;

    const waitForWidget = setInterval(() => {
      const wrapper = document.querySelector(".review-wrapper .sk-wrapper");

      if (!wrapper || initialized) return;

      initialized = true;
      clearInterval(waitForWidget);

      // Disable masonry layout
      wrapper.classList.remove("masonry", "js-masonry");

      let items = Array.from(wrapper.querySelectorAll(".sk-masonry-item"));

      items.forEach((item) => {
        // Remove google summary card
        if (item.querySelector(".sk-google-business")) {
          item.remove();
          return;
        }

        // Remove write review card
        if (item.querySelector('a[href*="writereview"]')) {
          item.remove();
          return;
        }

        item.style.position = "relative";
        item.style.left = "auto";
        item.style.top = "auto";
      });

      // Get cleaned cards
      const cleanItems = Array.from(
        wrapper.querySelectorAll(".sk-masonry-item")
      );

      // Clone cards for infinite loop
      const fragment = document.createDocumentFragment();

      cleanItems.forEach((item) => {
        fragment.appendChild(item.cloneNode(true));
      });

      wrapper.appendChild(fragment);
    }, 500);

    return () => clearInterval(waitForWidget);
  }, []);

  return (
    <div className="fixwidthDivtext">
      <div className="container">
        <div className="tile-text-with-text-shadow">
          <h2>TESTIMONIALS</h2>
        </div>

        <div className="commonone">
          <h4 className="theheadingcolor">What Our Customers Are Saying</h4>
          <div className="yellowline"></div>

          <span className="textformat">
            Discover testimonials from satisfied customers about our insurance
            services. See how we've protected and supported individuals and
            families.
          </span>
        </div>

        {/* Carousel */}
        <div className="uppercarsoul">
          <div className="backgroundcarasoul">
            <div
              className="sk-ww-google-reviews review-wrapper"
              data-embed-id="25655244"
            ></div>
          </div>
        </div>

        {/* Write Review Button */}
        <div className="google-review-summary">
          <a
            href="https://g.page/r/CdRCuiqSNoK_EAI/review"
            target="_blank"
            rel="noopener noreferrer"
            className="write-review-btn"
          >
            Write a Google Review <FaLocationArrow />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Testamonial;
